/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Audio_Embed_Export_Scan_FailedInputs */



/**
* | output |
* | --- |
* | "Could not read track layout: {error}" |
*
* @param {Audio_Embed_Export_Scan_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_scan_failed = /** @type {((inputs: Audio_Embed_Export_Scan_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Scan_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Impossible de lire le tracé des voies : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Gleisplan konnte nicht gelesen werden: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile leggere il layout del tracciato: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось прочитать схему путей: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se pudo leer el trazado de la vía: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`无法读取轨道布局：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`トラックレイアウトを読み取れませんでした: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`ट्रैक लेआउट को पढ़ा नहीं जा सका: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Não foi possível ler o layout da pista: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Could not read track layout: ${i?.error}`)
});